import { TOPICS_LAUNCH_PAD_CONSTANTS } from '../constants';

type TitleInfo = {
  titleText: string;
  hasLargeText: boolean;
};

const getTitleInfo = (page: string, position?: string): TitleInfo => {
  const { CONTENT } = TOPICS_LAUNCH_PAD_CONSTANTS;
  let titleText: string;
  let hasLargeText: boolean;

  if (page === 'Default') {
    titleText =
      position === 'Top'
        ? CONTENT.defaultPageTitle
        : CONTENT.defaultPageTitleBottom;
    hasLargeText = position === 'Top';
  } else if (page === 'Home') {
    titleText = CONTENT.homepageTitle;
    hasLargeText = true;
  } else {
    titleText = CONTENT.resultsPageTitle;
    hasLargeText = false;
  }

  return { titleText, hasLargeText };
};

export { getTitleInfo };
